// extracted by mini-css-extract-plugin
export default {"root":"QuestionHeader_root__VABqG","title":"QuestionHeader_title__WyL3B","info":"QuestionHeader_info__OZYRr","time":"QuestionHeader_time__dp0Rg"};